import { Button } from '@iwoca/orion';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './AddPhoneNumberForm.module.css';
import {
    ADD_PHONE_NUMBER,
    CHANGE_PHONE_NUMBER,
    TOGGLE_ADD_PHONE_NUMBER
} from '../../IdCheckVerificationModal.actions';
import { TDeserialisedPerson } from '../../IdCheckVerificationModal.types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeNumber: (personUID: string, phoneNumber: string) =>
        dispatch({ type: CHANGE_PHONE_NUMBER, personUID, phoneNumber }),
    addPhoneNumber: (person: TDeserialisedPerson) =>
        dispatch({ type: ADD_PHONE_NUMBER, person }),
    toggleAddPhoneNumber: (personUID: string) =>
        dispatch({ type: TOGGLE_ADD_PHONE_NUMBER, personUID })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const AddPhoneNumberForm = ({
    person,
    changeNumber,
    toggleAddPhoneNumber,
    addPhoneNumber
}: { person: TDeserialisedPerson } & PropsFromRedux) => {
    const intl = useIntl();
    return (
        <>
            {person.error && (
                <span className={styles.error}>
                    <FormattedMessage
                        id="_.modal.id_check_verification.error.enter_valid_number"
                        defaultMessage="Please enter a valid mobile number"
                    />
                </span>
            )}
            <div className={styles.AddPhoneNumberForm}>
                <input
                    data-testid="phoneNumberInput"
                    className={classNames(
                        styles.phoneNumberInput,
                        'fs-exclude'
                    )}
                    placeholder={intl.formatMessage({
                        id: '_.modal.id_check_verification.your_phone_number',
                        defaultMessage: 'Your mobile'
                    })}
                    type="text"
                    onChange={(event) =>
                        changeNumber(person.uid, event.target.value)
                    }
                />
                <Button
                    disabled={
                        !person.newPhoneNumber || person.addPhoneNumberPending
                    }
                    onClick={() => addPhoneNumber(person)}
                    className={styles.saveNumber}
                >
                    <FormattedMessage
                        id="_.modal.id_check_verification.save"
                        defaultMessage="Save"
                    />
                </Button>
                <button
                    className={styles.cancelNumber}
                    onClick={() => toggleAddPhoneNumber(person.uid)}
                >
                    <FormattedMessage
                        id="_.modal.id_check_verification.cancel"
                        defaultMessage="Cancel"
                    />
                </button>
            </div>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(AddPhoneNumberForm);
